import DocumentsPage from './DocumentsPage';

export default DocumentsPage;